"use strict";


angular.module("vendor")
.component("productDepositAutoComplete", {
    templateUrl: require("./product-deposit-auto-complete.component.html"),
    controller: ProductDepositAutoCompleteController,
    bindings: {
        model: "=",
        depositProduct: "=",
        name: "@"
    }
});

function ProductDepositAutoCompleteController($rootScope, $scope, gettextCatalog, ProductService) {
    var _this = this;

    this.autoCompleteOptions = {
        minimumChars: 1,
        data: function(term) {
            return ProductService.queryProductDeposits(term)
            .$promise.then(function(data) {
                angular.forEach(data.results, function(value, key) {
                    data.results[key].name = value.name[$rootScope.language];
                    if (!value.ImageFile || !value.ImageFile.thumbnail) {
                        value.ImageFile.thumbnail = "assets/no-image-" + $rootScope.locale + ".jpg";
                    }
                    var content = "<strong>" + data.results[key].name + "</strong>";
                    if (value.SupplierCode) {
                        content += "<div class='small'><em>" + value.SupplierCode + "</em></div>";
                    }
                    if (!value.enabled) {
                        content += "<div class=\"small text-alert\">" + gettextCatalog.getString("Product is disabled") + "</div>";
                    }
                    value.content = content;
                });
                return data.results;
            });
        },
        selectedTextAttr: "name",
        itemTemplateUrl: require("./product-deposit-auto-complete-item.component.html"),
        itemSelected: function(e) {
            _this.depositProduct.deposit_product_id = e.item.id;
            _this.depositProduct.name = e.item.name;
            _this.depositProduct.SupplierCode = e.item.SupplierCode;
            _this.depositProduct.ImageFile = e.item.ImageFile;
            _this.depositProduct.StandardPrice = e.item.StandardPrice;
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-deposits/product-deposit-auto-complete/product-deposit-auto-complete.component.js
// module id = 945
// module chunks = 0